export default __webpack_public_path__ + "static/media/bg3.e064c3a4.jpg";